module.exports = __webpack_public_path__ + "img/chargerID.52ab224c.png";